<template>
  <div>
    <div class="vs-row">
      <vs-col vs-xs="12">
        <div class="con-vs-card cardx outline-badge-primary">
          <div class="vs-card--content p-2">
            <div class="flex">
              <div
                class="px-3 my-auto"
              >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</div>
              <div class="ml-auto">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">
                  <i class="fas fa-external-link-alt"></i>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-0">
            <div class="vs-row">
              <vs-col vs-lg="3" vs-sm="3" class="bg-primary p-0" vs-xs="12">
                <div class="con-vs-card cardx overflow-hidden bg-transparent mb-0">
                  <div class="vs-card--content">
                    <div class="flex px-2 py-2 items-center font-normal">
                      <i class="fas fa-dollar-sign h2 mt-2 text-white mx-3"></i>
                      <div class="card-liner-content">
                        <h4 class="font-normal text-white">1,76,390</h4>
                        <p class="font-normal text-white mb-0">Investment Cost</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="con-vs-card cardx overflow-hidden bg-transparent mb-0">
                  <div class="vs-card--content">
                    <div class="flex px-2 py-2 items-center font-normal">
                      <i class="fas fa-donate h2 mt-2 text-white mx-3"></i>
                      <div class="card-liner-content">
                        <h4 class="font-normal text-white">1,50,390</h4>
                        <p class="font-normal text-white mb-0">Current Value</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="con-vs-card cardx overflow-hidden bg-transparent mb-0">
                  <div class="vs-card--content">
                    <div class="flex px-2 py-2 items-center font-normal">
                      <i class="fab fa-creative-commons-nc h2 mt-2 text-white mx-3"></i>
                      <div class="card-liner-content">
                        <h4 class="font-normal text-white">-15,568</h4>
                        <p class="font-normal text-white mb-0">Total Profit/Loss</p>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="3" class="py-3" vs-xs="12">
                <chartjs-bar-chart
                  :height="180"
                  :data="ChartOptions.mainbarchart.data"
                  :options="ChartOptions.mainbarchart.options"
                ></chartjs-bar-chart>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                <vs-card class="cardx relative border-0">
                  <div class="flex items-center">
                    <div class="card-liner-content">
                      <h5 class="font-medium mb-0">Total Investment</h5>
                      <p class="font-medium mt-0">San Francisco, California, USA</p>
                    </div>
                    <vs-chip
                      class="top-0 right-auto mt-3 ml-3 text-center rounded-full opacity-50"
                      color="success"
                    >
                      <span class="h5 px-2 py-2">$</span>
                    </vs-chip>
                  </div>

                  <div class="vs-row">
                    <vs-col vs-lg="6" vs-xs="6">
                      <div class="border-0 outline-badge-info mt-5 p-4 rounded text-center">
                        <span class="h5 mb-0">Income</span>
                        <br />$78,600
                      </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-xs="6">
                      <div class="border-0 outline-badge-success mt-5 p-4 rounded ml-2 text-center">
                        <span class="h5 mb-0">Sales</span>
                        <br />$1,24,600
                      </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-xs="6">
                      <div class="border-0 outline-badge-dark mt-5 p-4 rounded text-center">
                        <span class="h5 mb-0">Users</span>
                        <br />4,600
                      </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-xs="6">
                      <div class="border-0 outline-badge-danger mt-5 p-4 rounded ml-2 text-center">
                        <span class="h5 mb-0">Orders</span>
                        <br />2,600
                      </div>
                    </vs-col>
                  </div>
                </vs-card>
              </vs-col>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-0">
            <div class="flex items-center px-3">
              <span class="text-6xl text-primary mr-5 h2">$</span>
              <div class="card-liner-content text-right ml-auto">
                <h4 class="card-title m-0">Investment</h4>
                <span class="text-success">
                  <i class="ion ion-android-arrow-dropup"></i> 15% higher
                </span>
                <span class="text-muted">20.5K</span>
              </div>
            </div>
            <vue-apex-charts
              height="130"
              type="area"
              :options="ChartOptions.investment.options"
              :series="ChartOptions.investment.series"
            ></vue-apex-charts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-0">
            <div class="flex items-center px-3">
              <i class="fas fa-donate card-liner-icon text-6xl mt-2 text-success"></i>
              <div class="card-liner-content text-right ml-auto">
                <h4 class="card-title m-0">Total Profit</h4>
                <span class="text-success">
                  <i class="ion ion-android-arrow-dropup"></i> 15% higher
                </span>
                <span class="text-muted">20.5K</span>
              </div>
            </div>
            <vue-apex-charts
              height="150"
              type="area"
              :options="ChartOptions.profit.options"
              :series="ChartOptions.profit.series"
            ></vue-apex-charts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content px-3 py-5 bg-primary h-full text-center">
            <div class="my-5">
              <span class="icon-people h1 bg-primary text-white"></span>
              <h2 class="mt-4 text-white">Unique Visitors</h2>
              <span class="h4 text-white">20.5K</span>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-0">
            <div class="flex items-center px-3">
              <i class="fab fa-creative-commons-nc card-liner-icon text-6xl mt-2 text-info"></i>
              <div class="card-liner-content text-right ml-auto">
                <h4 class="card-title m-0">STATS</h4>
                <span class="text-success">
                  <i class="ion ion-android-arrow-dropup"></i> 15% higher
                </span>
                <span class="text-muted">20.5K</span>
              </div>
            </div>
            <vue-apex-charts
              height="150"
              type="area"
              :options="ChartOptions.stats.options"
              :series="ChartOptions.stats.series"
            ></vue-apex-charts>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Transactions</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <ul class="list-group list-unstyled">
              <li class="p-2 border bottom">
                <div class="flex items-center">
                  <div class="text-center rounded bg-primary text-white p-2">
                    <small class="d-block">MAR</small>
                    <br />
                    <span class="h6">28</span>
                  </div>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Jonathan</span>
                    <br />
                    <p class="mb-0 font-semibold">SIP Purchase</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    +500
                    <br />
                    <small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-2 border bottom">
                <div class="flex items-center">
                  <div class="text-center rounded bg-primary text-white p-2">
                    <small class="d-block">APR</small>
                    <br />
                    <span class="h6">12</span>
                  </div>
                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">kelvin</span>
                    <br />
                    <p class="mb-0 font-semibold tx-s-12">Mutual Funds</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-danger">
                    -500
                    <br />
                    <small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-2 border bottom">
                <div class="flex items-center">
                  <div class="text-center rounded bg-primary text-white p-2">
                    <small class="d-block">MAY</small>
                    <br />
                    <span class="h6">13</span>
                  </div>
                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Peter</span>
                    <br />
                    <p class="mb-0 font-semibold tx-s-12">Equity</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-danger">
                    +500
                    <br />
                    <small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-2 border bottom">
                <div class="flex items-center">
                  <div class="text-center rounded bg-primary text-white p-2">
                    <small class="d-block">JUN</small>
                    <br />
                    <span class="h6">23</span>
                  </div>
                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Ray Sin</span>
                    <br />
                    <p class="mb-0 font-semibold tx-s-12">Commodity</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-danger">
                    +500
                    <br />
                    <small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-2">
                <div class="flex items-center">
                  <div class="text-center rounded bg-primary text-white p-2">
                    <small class="d-block">JUL</small>
                    <br />
                    <span class="h6">16</span>
                  </div>
                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Abexon Dixon</span>
                    <br />
                    <p class="mb-0 font-semibold tx-s-12">Real Estate</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    +500
                    <br />
                    <small class="d-block">USD</small>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-5 text-center">
            <div class="my-auto">
              <img src="@/assets/images/wallet.png" alt="author" width="48" class="my-auto" />
            </div>
            <div class="content my-5">
              <span class="mb-0 font-w-600 h5">Lorem ipsum dolor sit</span>
              <br />
              <p
                class="mb-0 font-w-500 tx-s-12"
              >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
            </div>
            <div class="card bg-primary rounded my-5 text-left">
              <div class="card-body">
                <div class="flex px-2 py-2 items-center font-normal">
                  <i class="fas fa-dollar-sign h2 mt-2 text-white mx-3"></i>
                  <div class="card-liner-content">
                    <h4 class="font-normal text-white">1,76,390</h4>
                    <p class="font-normal text-white mb-0">Investment Cost</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-5">
              <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
            </div>
            <ul class="list-none my-5">
              <li class="inline mx-2">
                <i class="fab fa-cc-mastercard h1 text-primary"></i>
              </li>
              <li class="inline mx-2">
                <i class="fab fa-cc-visa h1 text-primary"></i>
              </li>
              <li class="inline mx-2">
                <i class="fab fa-cc-paypal h1 text-primary"></i>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Accounts & Cards</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <ul class="list-group list-unstyled">
              <li class="p-3 border bottom">
                <div class="flex items-center">
                  <i class="fab fa-cc-mastercard h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Master Card</span>
                    <br />
                    <p class="mb-0 font-semibold">1234 1234 1234 1234</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    Active
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                  <i class="fab fa-cc-visa h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Visa Card</span>
                    <br />
                    <p class="mb-0 font-semibold">1234 1234 1234 1234</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-danger">
                    Disable
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                  <i class="fab fa-cc-paypal h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Paypal</span>
                    <br />
                    <p class="mb-0 font-semibold">1234 1234 1234 1234</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    Active
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                  <i class="fab fa-cc-amazon-pay h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Amazon Pay</span>
                    <br />
                    <p class="mb-0 font-semibold">amazon-pay@abc</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    Active
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                  <i class="fab fa-cc-mastercard h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Master Card</span>
                    <br />
                    <p class="mb-0 font-semibold">1234 1234 1234 1234</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    Active
                  </div>
                </div>
              </li>
              <li class="p-3">
                <div class="flex items-center">
                  <i class="fab fa-cc-stripe h1 text-primary"></i>

                  <div class="align-self-center pl-4">
                    <span class="mb-0 font-bold">Stripe Payment</span>
                    <br />
                    <p class="mb-0 font-semibold">1234 1234 1234 1234</p>
                  </div>
                  <div class="ml-auto my-auto font-bold text-right text-success">
                    Active
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Recent Invoices</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <ul class="list-group list-unstyled">
              <li class="p-3 border bottom">
                <div class="flex items-center">
                 <span class="badge outline-badge-info my-auto rounded p-2 whitespace-no-wrap">Paid</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">Payment</span>
                    <br />
                    <p class="mb-0 font-semibold">SIP Purchase</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                 <span class="badge outline-badge-danger my-auto rounded p-2 whitespace-no-wrap">Cancele</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">Service Payment</span>
                    <br />
                    <p class="mb-0 font-semibold">Mutual Funds</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                 <span class="badge outline-badge-warning my-auto rounded p-2 whitespace-no-wrap">Standby</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">Membership</span>
                    <br />
                    <p class="mb-0 font-semibold">Equity</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                 <span class="badge outline-badge-info my-auto rounded p-2 whitespace-no-wrap">Paid</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">Renewal</span>
                    <br />
                    <p class="mb-0 font-semibold">Commodity</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-3 border bottom">
                <div class="flex items-center">
                 <span class="badge outline-badge-danger my-auto rounded p-2 whitespace-no-wrap">Hold</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">New Purchase</span>
                    <br />
                    <p class="mb-0 font-semibold">Real Estate</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              <li class="p-3">
                <div class="flex items-center">
                 <span class="badge outline-badge-info my-auto rounded p-2 whitespace-no-wrap">Process</span>
                  <div class="align-self-center ml-auto pl-4 text-right">
                    <span class="mb-0 font-bold">Widrawal</span>
                    <br />
                    <p class="mb-0 font-semibold">Switch Out</p>
                  </div>
                  <div class="ml-3 my-auto font-bold text-right text-success">
                    $500<br><small class="d-block">USD</small>
                  </div>
                </div>
              </li>
              
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Visits by Countries</h6>
            </div>
          </header>

          <div class="vs-card--content p-0">
            <vs-table stripe :data="rows">
              <template slot="thead">
                <vs-th>Country</vs-th>
                <vs-th>Visits</vs-th>
                <vs-th>Sessions</vs-th>
                <vs-th>Page View</vs-th>
              </template>
              <template>
                <vs-tr class="border top" :key="indextr" v-for="(row, indextr) in rows">
                  <vs-td :data="row.country">{{row.country}}</vs-td>
                  <vs-td :data="row.visit" :class="row.visittextclass">
                    {{row.visit}}
                    <i v-if="row.visiticon" :class="'ion '+row.visiticon"></i>
                  </vs-td>
                  <vs-td :data="row.session" :class="row.sessiontextclass">
                    {{row.session}}
                    <i v-if="row.sessionicon" :class="'ion '+row.sessionicon"></i>
                  </vs-td>
                  <vs-td :data="row.view" :class="row.viewtextclass">
                    {{row.view}}
                    <i v-if="row.viewicon" :class="'ion '+row.viewicon"></i>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import ChartjsBarChart from "../components/chartjs/ChartjsBarChart.vue";
import VueApexCharts from "vue-apexcharts";
import AccountChart from "@/demo-data/Account.js";
export default {
  components: {
    ChartjsBarChart,
    VueApexCharts,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      ChartOptions: AccountChart[0],
      rows: [
        {
          country: "France",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "United States",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "China",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Spain",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Italy",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "United Kingdom",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
        {
          country: "Malaysia",
          visit: "2,51,520",
          visittextclass: "text-success",
          visiticon: "ion-arrow-graph-up-right",
          session: "3,23,55,479",
          sessiontextclass: "text-danger",
          sessionicon: "ion-arrow-graph-down-right",
          view: "23,27,346",
          viewtextclass: "text-info",
          viewicon: "",
        },
      ],
    };
  },
};
</script>